import { configureStore } from '@reduxjs/toolkit';
import { rootReducer } from '../reducers';
export let store;
export const createStore = (preloadedState = {}) => {
    store = configureStore({
        reducer: rootReducer,
        preloadedState,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware({
            serializableCheck: false,
        }),
    });
    return store;
};
